function findScrollContainer(element) {
  const dialogWrapper = element.closest('.el-dialog__wrapper');
  if (dialogWrapper && dialogWrapper.scrollHeight > dialogWrapper.clientHeight + 1) {
    return dialogWrapper;
  }

  let node = element.parentElement;

  while (node && node !== document.body) {
    const { overflowY } = window.getComputedStyle(node);
    const canScroll =
      (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight + 1;

    if (canScroll || node.classList.contains('el-dialog__body')) {
      return node;
    }

    node = node.parentElement;
  }

  return null;
}

function scrollWithinContainer(target, container) {
  const containerRect = container.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const scrollTop =
    container.scrollTop +
    targetRect.top -
    containerRect.top -
    container.clientHeight / 2 +
    targetRect.height / 2;

  container.scrollTo({
    top: Math.max(0, scrollTop),
    behavior: 'smooth',
  });
}

export function scrollToFirstError(container) {
  if (!container) {
    return;
  }

  let target = container.querySelector('.form-input--error');

  if (!target) {
    const errorEl = container.querySelector('.form-input__error');
    if (errorEl) {
      target =
        errorEl.closest('.form-input') ||
        errorEl.closest('.dialog-add-account__form-item') ||
        errorEl.closest('.dialog-add-account__form-col') ||
        errorEl.closest('.dialog-add-account__form-agree') ||
        errorEl.closest('.input__item-checkbox') ||
        errorEl.parentElement;
    }
  }

  if (!target) {
    return;
  }

  const scrollContainer = findScrollContainer(target);

  if (scrollContainer) {
    scrollWithinContainer(target, scrollContainer);
  } else {
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  const focusable = target.querySelector(
    'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled])'
  );

  if (focusable) {
    try {
      focusable.focus({ preventScroll: true });
    } catch (e) {
      focusable.focus();
    }
  }
}
